import React, { Component, useState, useEffect } from "react";
import "../../Page/Dashboard/index.css";
import "../index.css";
import "./index.css";
import TopMenu from "../Layout/TopMenu";
import MenuDesktop from "../Layout/MenuDesktop";
import { MDBRow, MDBCol } from "mdbreact";
import { IoSearch } from "react-icons/io5";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import fetch from "isomorphic-fetch";

import createSpeechServicesPonyfill from "web-speech-cognitive-services";

import { NavLink, withRouter } from "react-router-dom";
import {
  RiArrowDownSLine,
  RiArrowUpSLine,
  RiArrowRightSLine,
} from "react-icons/ri";
import NavBar from "../Layout/NavBar";
import mixpanel from "mixpanel-browser";
import { HiLightningBolt, HiSortAscending } from "react-icons/hi";

import { firebase } from "../../../firebase/config";

import { TiTick } from "react-icons/ti";
import VisibilitySensor from "react-visibility-sensor";
import Scroll from "react-scroll";
const scroll = Scroll.animateScroll;

const SUBSCRIPTION_KEY = "c720988746a245e8a6df46f90abd2acf";
const REGION = "eastus";

const { SpeechRecognition: AzureSpeechRecognition } =
  createSpeechServicesPonyfill({
    credentials: {
      region: REGION,
      subscriptionKey: SUBSCRIPTION_KEY,
    },
  });
SpeechRecognition.applyPolyfill(AzureSpeechRecognition);
const recognition = SpeechRecognition.getRecognition();
const Demo = () => {
  const [call, setCall] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [text, setText] = useState("Calling...");
  const [audioData, setAudioData] = useState([]);
  const [currentChunk, setCurrentChunk] = useState(null);
  const [callStarted, setCallStarted] = useState(false);

  const [gainNode, setGainNode] = useState(null);
  const [onboarded, setOnboarded] = useState(null);

  const [aiSpeech, setAISpeech] = useState(false);
  const [shadowRadius, setShadowRadius] = useState(20);
  const [started, setStarted] = useState(false);
  const [conversationId, setConversationId] = useState("");
  const [audioChunks, setAudioChunks] = useState([]);
  const [audioUrl, setAudioUrl] = useState("");
  const [prevInterimTranscript, setPrevInterimTranscript] = useState("");
  const [interimTranscriptQueue, setInterimTranscriptQueue] = useState([]);
  const [isPlaying, setIsPlaying] = useState(false);

  const {
    resetTranscript,
    browserSupportsSpeechRecognition,
    interimTranscript,
    finalTranscript,
    isMicrophoneAvailable,
    listening,
  } = useSpeechRecognition();

  useEffect(() => {
    async function startListeningSpeech() {
      try {
        await SpeechRecognition.startListening({
          continuous: true,
          language: "en-US",
        });
      } catch (error) {
        console.error(error);
      }
    }

    if (call) {
      startListeningSpeech();
    }
  }, [call]);

  useEffect(() => {
    if (finalTranscript) {
      triggerTTS(finalTranscript);
      resetTranscript();
    }
  }, [finalTranscript]);
  useEffect(() => {
    if (!currentChunk && audioChunks.length > 0 && !interimTranscript && call) {
      playAudio(audioChunks.shift(), call);
    }
  }, [currentChunk, audioChunks, interimTranscript, call]);

  const playAudio = (chunk, calling) => {
    if (call && chunk && chunk.byteLength > 0) {
      const audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      const source = audioContext.createBufferSource();

      audioContext.decodeAudioData(chunk, function (buffer) {
        source.buffer = buffer;
        // setAiFinished(false);

        const analyser = audioContext.createAnalyser();
        analyser.fftSize = 256;

        const gainNode = audioContext.createGain();
        source.connect(gainNode);
        gainNode.connect(audioContext.destination);

        // Create low-pass filter
        const filter = audioContext.createBiquadFilter();
        filter.type = "lowpass";
        filter.frequency.setValueAtTime(2000, audioContext.currentTime);
        gainNode.connect(filter);
        filter.connect(audioContext.destination);

        setGainNode(gainNode);
        source.start(0);
        setIsPlaying(true);
        source.onended = () => {
          setCurrentChunk(null);
          // setAiFinished(true);

          setIsPlaying(false);
        };
      });
      setCurrentChunk(source);
    } else {
      return null;
    }
  };

  const triggerTTS = async (text) => {
    try {
      if (call) {
        setGenerating(true);

        const response = await fetch("http://localhost:8000/voiceChanger", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            text: text,
            voiceID: "RmFMi1u2DmpPTOVQgZkg",
          }),
        });

        if (!response.ok) {
          throw new Error("Error during call");
        }

        const arrayBuffer = await response.arrayBuffer();

        // setAiChunks([arrayBuffer]);
        handleNewAudioChunk(arrayBuffer);

        // stopListening();
        setGenerating(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleNewAudioChunk = (chunk) => {
    setAudioChunks([...audioChunks, chunk]);
  };

  const playNextAudio = (audioContext) => {
    if (audioData.length === 0) {
      return;
    }
    const source = audioContext.createBufferSource();
    source.buffer = audioData[0];
    source.connect(audioContext.destination);
    source.start(0);
    source.onended = () => {
      setAudioData((prevAudioData) => prevAudioData.slice(1));
      playNextAudio(audioContext);
    };
  };

  return (
    <>
      <MDBCol
        style={{
          width: "105vw",
          overflowX: "hidden",
          paddingBottom: 0,
          height: "100vh",
          backgroundColor: "black",
        }}
        size="12"
      >
        <MDBRow style={{ marginTop: 0 }}>
          <MDBCol size="12">
            <NavLink to="/" exact onClick={() => window.scrollTo(0, 0)}>
              <p
                style={{
                  fontFamily: "Grifter",
                  color: "white",
                  fontSize: 23,
                  fontWeight: "900",
                  marginTop: 32,
                  display: "inline-block",
                  marginLeft: 85,
                }}
              >
                YouDub<sup>TM</sup>
              </p>
            </NavLink>
          </MDBCol>

          <div
            className="d-flex justify-content-center"
            style={{ width: "100vw" }}
          >
            <MDBRow style={{ marginTop: -10, width: 870 }}>
              <MDBCol
                className="d-flex justify-content-center "
                style={{ padding: 3 }}
                size="12"
              >
                <div
                  style={{ height: 430, width: 450, zIndex: 6, marginTop: 0 }}
                >
                  <MDBRow>
                    <MDBCol
                      className="d-flex justify-content-center "
                      size="12"
                    >
                      <p
                        style={{
                          color: "white",
                          fontFamily: "PlusJSBold",
                          fontSize: 30,
                          textAlign: "center",
                        }}
                      >
                        Test the Customer Call below to see how YouDub works
                      </p>
                    </MDBCol>
                    <MDBCol
                      className="d-flex justify-content-center "
                      size="12"
                    >
                      <div
                        style={{
                          height: 50,
                          width: 200,
                          backgroundColor: "green",
                          color: "white",
                          fontFamily: "PlusJSBold",
                          marginTop: 23,
                          fontSize: 24,
                        }}
                        onClick={() => setCall(true)}
                        className="d-flex justify-content-center "
                      >
                        <p style={{ marginTop: 6 }}>
                          {call ? "Listening" : "Play"}
                        </p>
                      </div>
                    </MDBCol>

                    <MDBCol
                      className="d-flex justify-content-center "
                      size="12"
                    >
                      <p
                        className="d-inline"
                        style={{
                          fontFamily: "PlusJSRegular",
                          fontSize: 11,
                          marginTop: 20,
                          color: "white",
                        }}
                      >
                        © Copyright 2023 YouDub, LLC
                      </p>
                    </MDBCol>
                  </MDBRow>
                </div>
              </MDBCol>
            </MDBRow>
          </div>
        </MDBRow>
      </MDBCol>
    </>
  );
};

export default withRouter(Demo);
